// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"743f59b3","375":"d5a1cff0","488":"6bdb6efe"}[chunkId] + ".chunk.js";
};